import { Pipe, PipeTransform } from '@angular/core';
import { Schema } from '@app/core/_models/schema';

@Pipe({
  name: 'propertyIsFieldRequired',
})

export class PropertyIsFieldRequiredPipe implements PipeTransform {
  public transform(properties: Schema, controlName: string): boolean {
    return properties.isFieldRequired(controlName);
  }
}
